<template>
  <div class="task-page">
    <div class="panel-left" :class="showLeftPanel ? 'plan-list-show' : 'pLeft'">
      <div class="planSearch">
        <el-input style="width: 75%" v-model="searchForm.taskName" @keyup.enter.native="handleSearch" clearable
          @clear="handleSearch" placeholder="请输入任务名称">
        </el-input>
        <span> | </span>
        <img @click="handleSearch" src="@src/common/assets/images/search.png" alt="" />
      </div>
      <div class="list-search map-blur-panel__title flex-right valign-center" v-if="false">
        <div class="point-icon iconfont-lunan icon-lunan-gengduoda ml10" :style="{ color: isSearch ? '#fff' : '', }"
          style="margin-right: 5px" @click.stop="() => { isSearch = !isSearch; }"></div>
        <el-collapse-transition v-if="isSearch">
          <div class="list-search_form">
            <el-form v-model="searchForm" label-width="80px" style="width: 300px">
              <el-form-item label="任务名称">
                <el-input v-model="searchForm.taskName" placeholder="请输入任务名称"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button @click="handleSearchCancel">重置</el-button>
                <el-button type="primary" @click="handleSearch">查询</el-button>
              </el-form-item>
            </el-form>
          </div>
        </el-collapse-transition>
      </div>
      <div class="box-card" v-loading="listLoading" element-loading-text="数据加载中"
        element-loading-spinner="el-icon-loading">
        <el-scrollbar style="height: 100%" ref="refScrollbar">
          <div class="panel-left_content" v-for="item in tasks" :key="item.code">
            <div class="content_item map-blur-panel__list-item" style="cursor: pointer" @click.stop="handleDetail(item)"
              :class="activePlanInfo && item.code == activePlanInfo.code ? 'active' : ''">
              <!--  1.待巡逻 2.巡逻中 3.已完成 4.已超时-->
              <span :class="['status-btn', item.status == 1 ? 'isPending' : item.status == 2 ? 'isOther' : item.status == 3
                ? 'isFinised' : 'isOvertime',]">{{ taskStatusList[item.status - 1] }}</span>
              <div class="item-label" style="font-size: 16px">
                {{ item.name }}
              </div>

              <div class="item-info flex-row">
                <div class="item-info_left">
                  <div class="item-time">
                    开始时间：
                    {{ $utils.getDateStr(item.startTime, "YYYY-MM-DD HH:mm:ss") }}
                  </div>
                  <div class="item-time">
                    结束时间：
                    {{ $utils.getDateStr(item.endTime, "YYYY-MM-DD HH:mm:ss") }}
                  </div>
                </div>
                <div class="item-info_right" v-if="item.status != '3'">
                  <el-button type="text" title="开始巡逻" class="font-24"
                    :class="item.status == 2 ? 'el-icon-video-pause' : 'el-icon-video-play'"
                    @click.stop="handlePlayPanel(item)"></el-button>
                </div>
              </div>
            </div>
          </div>
          <div v-if="!tasks.length" class="no-data-text">
            <div>
              <img src="@/common/assets/images/empty.svg" class="no-data_img" />
            </div>
            <span>暂无数据</span>
          </div>
        </el-scrollbar>
      </div>

      <div class="data-pagination map-blur-panel__title" v-if="false">
        <el-pagination small layout="total, prev, pager, next" :total="total" :pageSize="leftPageSize" :pageNo="1"
          :current-page="leftCurrentPage" @current-change="pageChange">
        </el-pagination>
      </div>
      <div class="plan-list-toolbar">
        <div class="map-blur-panel__expand-button left iconfont-lunan"
          :class="showLeftPanel ? 'icon-lunan-shousuocaidan' : 'icon-lunan-shousuocaidan-copy'"
          @click="showPlanListPanel"></div>
      </div>
    </div>
    <!-- 任务详情 -->
    <taskDetail ref="taskDetail" :showPanel="showDetailPanel" :tableDetail="tableDetail"
      @handleCloseDetail="handleDetailClose" @handleExactor="handleExactor" />
    <!-- 视频巡逻弹窗 -->
    <app-panel isScreen :title="panelTitle" :isExpand="showRightPanel" :transparent="isTransparent"
      @cancel="handleClose()" :width="1350">
      <div class="panel">
        <div class="left-video">
          <div id="playerRef" style="height: calc(100% - 50px)" ref="playerRef">
            <dh-player ref="dhPlayerPatrol" videoId="dhPlayerPatrol"
              :shieldClass="['el-message', 'el-message-box', 'el-dialog', 'el-dialog__wrapper', 'el-picker-panel', 'hover-blur-panel']"
              :windowType="windowType" :division="division" :showBar="showBar" @realSuccess="realSuccess"
              @clickWindow="clickWindow" @picCap="picCap" @videoDownloadSuccess="videoDownloadSuccess"></dh-player>
          </div>
          <div class="control-btns">
            <span class="btns_play"> </span>
            <div class="control_right valign-center">
              <!-- <span class="cur" title="打卡" @click="handleAllStop">
                <i
                  title="全部关闭"
                  class="icon iconfont-lunan icon-lunan-tingzhi"
                ></i>
              </span> -->
              <div class="cur" title="打卡" @click="doMark" v-if="isDoMark">
                <i class="el-icon-thumb" title="打卡" style="font-size: 26px;"> </i>
                <div>
                  <span class="bg"></span>
                </div>
              </div>
              <div class="cur" title="上报告警" @click="reportAlarm" v-if="!taskPlayOver">
                <i class="icon iconfont-lunan icon-lunan-shoudonggaojing" title="上报告警" style="font-size: 26px;"></i>
              </div>

              <div class="cur" title="提交报告" @click="submitReport" v-if="isSubmitReport">
                <i class="icon iconfont-add icontijiao" style="font-size: 26px;"> </i>
                <div>
                  <span class="bg"></span>
                </div>
              </div>
              <!-- <div class="cur" @click="handleFullScreen">
                <i class="icon iconfont-lunan icon-lunan-quanping" title="全屏"></i>
              </div> -->
            </div>
          </div>
        </div>
        <div class="right-list">
          <el-scrollbar>
            <div class="list-item" v-for="(item, index) in cameraList" :key="item.detailCode">
              <div class="list-item_icon" style="width: 20px; margin-right: 5px">
                <i class="el-icon-caret-right" v-if="item.isPlay"></i>
              </div>
              <div class="list-item_index">{{ index + 1 }}</div>
              <div class="list-item_name">{{ item.cameraName }}</div>
            </div>
          </el-scrollbar>
        </div>
      </div>
      <reportAlarmPanel ref="alarmPanel" :taskDetailCode="taskDetailCode" :code="code" :showAlarmPanel="showAlarmPanel"
        @handleClosePanel="handleClosePanel" @handleSnap="handleSnap" />
    </app-panel>
    <el-dialog :visible.sync="dialogVisible" append-to-body width="650px" :title="$t('videoPatrol.title.patrolReport')">
      <el-form ref="form" label-width="120px" :model="form" label-suffix="：">
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('videoPatrol.label.taskName')">
              <el-input v-model="form.taskName" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('videoPatrol.label.Responsible')">
              <el-input v-model="form.processorName" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('videoPatrol.label.planClock')">
              <el-input v-model="form.signCount" disabled />
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item :label="$t('videoPatrol.label.realClock')">
              <el-input v-model="form.realSignCount" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item :label="$t('videoPatrol.label.loseClock')">
              <el-input v-model="form.miss" disabled />
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="24">
            <el-form-item :label="$t('videoPatrol.label.reportRemark')" prop="desc" :rules="[
              {
                required: true,
                message: this.$t('videoPatrol.message.reportRemark'),
                trigger: 'blur',
              },
              {
                min: 0,
                max: 250,
                message: this.$t('videoPatrol.message.remarkValue'),
                trigger: 'blur',
              },
            ]">
              <el-input type="textarea" :rows="3" placeholder="请输入备注" maxlength="200" show-word-limit
                v-model="form.desc" />
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div class="picture" v-if="showPictur">
        <!--提交报告返回图片-->
        <el-carousel trigger="click" height="200px">
          <el-carousel-item v-for="item in picList" :key="item">
            <img :src="getImgPath(item)" height="100%" />
          </el-carousel-item>
        </el-carousel>
      </div>
      <div class="present" slot="footer">
        <el-button @click="dialogVisible = false" type="info"> 取消 </el-button>
        <el-button @click="addReport(form)" type="primary">{{
          $t("videoPatrol.button.confirm")
        }}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import DhPlayer from "@/components/business/dh-player/index.vue"
import appPanel from "@src/components/business/app-panel/index.vue";
import taskDetail from "../components/task-detail.vue";
import reportAlarmPanel from "../components/reportAlarm.vue";
import { api } from "../api";
import utils from "@src/common/utils";
import { Dic, Dates } from "$utils";
export default {
  components: {
    appPanel,
    DhPlayer,
    taskDetail,
    reportAlarmPanel,
  },
  data() {
    return {
      taskPlayOver: false,
      activePlanInfo: null,
      leftPageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      leftCurrentPage: 1,
      isTransparent: true,
      showRightPanel: false,
      showDetailPanel: false, //任务详情面板
      showAlarmPanel: false, //上报告警面板
      panelTitle: "",
      searchForm: {},
      isSearch: false,
      tasks: [
        // { taskName: "ceshi" }
      ],
      total: 0,
      // pageSize: utils.Cache.get("CURRENT_PAGESIZE") || 10,
      pageSize: 30,
      pageNo: 1,
      currentPage: 1,
      dateRangeArr: [],
      tableDetail: {},
      taskStatusList: ["待执行", "执行中", "已完成", "已暂停"],
      cameraList: [],
      //   alarmTypes: Dic.find("SENU085"),
      isPlay: false,
      playerIndex: null,
      playList: [],
      playTime: "",
      endTime: "",
      playOption: {
        // videoSrc: 'http://nebula-playback.qiniudn.com/test-playback/flv/sample.flv',
        // videoSrc: 'http://127.0.0.1:9003/09d0359b1dd329dc7b0e13b30868d975.mp4',
        videoSrc: "",
        deviceId: "1",
        cameraType: "",
        posterSrc: "/images/theme/newDark/default.png",
      },
      screenSet: false,
      isDoMark: false,
      code: "",
      timer: null,
      currentTask: {},
      cameraId: null,
      cameratitle: null,
      taskDetailCode: "",
      carouselType: "",
      oTimer: {
        startTaskTimer: null,
      },
      curCamera: {
        playTime: "",
        playTimeCopy: "",
      },
      taskName: "",
      windowCode: "",
      cameraPointId: "cameraPointId",
      reportTime: "",
      isSubmitReport: false,
      dialogVisible: false,
      form: {
        signCount: "",
        realSignCount: "",
        desc: "",
      },
      showPictur: false,
      pointData: [],
      signCount: "",
      showLeftPanel: false,
      listLoading: false,
      // 视频
      // 播放类型
      windowType: 0,
      // 分割窗格
      division: 1,
      // 控制栏的显示与隐藏
      showBar: false,
      // 当前窗口
      currentNum: 0,
      // 当前播放信息
      currentVideoInfo: null,
      snapImg: null,
      firstIp: ''
    };
  },
  created() {
    let hostName = location.hostname;
    let ipIndex = hostName.indexOf('.')
    if (ipIndex !== -1) {
      this.firstIp = hostName.substring(0, ipIndex)
    }
  },
  computed() { },
  beforeDestroy() {
    this.$map.hideMap2D();
    clearInterval(this.curCamera.playTime);
  },
  watch: {
    // 当前任务
    currentTask: {
      deep: true,
      handler: function (newVal) {
        let n = 0;
        this.taskPollingAction(n);
      },
    },
    // 当前摄像机
    curCamera: {
      deep: true,
      handler: function (newVal) {
        this.panelTitle = "巡逻任务【" + this.taskName + "】" + "本组倒计时" + this.curCamera.playTime + "秒";
      },
    },
  },
  mounted() {
    this.scrollbar();
    this.$map.showMap2D(this.initPage);
    this.showLeftPanel = true;
    // this.init();
    // this.queryDevicesByAreas();
    // this.getTaskList();
  },

  methods: {
    // 获取直播url并播放
    queryVideoRtsp(option) {
      const param = {
        deviceIdList: [option.thirdCameraId],
        protocol: 'rtsp'
      }
      this.$fetch(api.queryRealTimeVideoRtsp, param).then(res => {
        if (res.success) {
          let inNetUrl = res.returnObj[0].url.substring(0, res.returnObj[0].url.indexOf('|'))
          let outNetUrl = res.returnObj[0].url.substr(res.returnObj[0].url.indexOf('|') + 1, res.returnObj[0].url.length)
          // console.log('内网', inNetUrl)
          // console.log('外网', outNetUrl)
          let rtspUrl = ''
          if (this.firstIp == '10' || this.firstIp == '172' || this.firstIp == '192') {
            rtspUrl = inNetUrl
          } else {
            rtspUrl = outNetUrl
          }
          let rtspObj = {
            channelId: res.returnObj[0].deviceId,
            path: rtspUrl,
            cameraType: res.returnObj[0].cameraType,
            name: option.name
          }
          this.realByUrl(rtspObj)
        } else {
          this.$message.error(res.msgContent)
        }
      })
    },// 通过rtsp流播放实时预览
    realByUrl(deviceInfo) {
      let param = {
        channelName: deviceInfo.name,
        channelId: deviceInfo.channelId,  // 通道ID,必传
        path: deviceInfo.path,  // 流地址 
        redirect: false, // 9090端口为true   9100端口为false 必传
        cameraType: deviceInfo.cameraType
      }
      // console.log(param, '播放参数')
      this.$refs.dhPlayerPatrol.realByUrl(param, this.currentNum) // 播放的窗口序号 (从0开始计数，表示第一个窗口)
      this.currentNum = this.currentNum + 1
    },
    // 播放成功
    realSuccess(info) {
      this.currentNum = info.snum
      this.currentVideoInfo = info
      // 视频开始播放，计时器开始计时
      if (this.oTimer.startTaskTimer) {
        return;
      }
      this.executeTaskTimer();
    },
    // 点击当前播放窗口获取播放信息
    clickWindow(snum, data) {
      if (data) {
        this.currentNum = snum
        this.currentVideoInfo = data
        this.$refs.alarmPanel.alarmInfo.name = ""
        this.$refs.alarmPanel.alarmInfo.thirdCameraId = ""
        this.$refs.alarmPanel.alarmInfo.alarmLevel = ""
        this.$refs.alarmPanel.alarmInfo.alarmType = ""
        this.$refs.alarmPanel.alarmInfo.desc = ""
        this.$refs.alarmPanel.alarmInfo.picture = ""
        this.$refs.alarmPanel.alarmInfo.pictureList = []
        this.cameraList = []
        this.reportAlarm()
      }
    },
    // 抓图回调
    picCap(item) {
      // console.log(item)
      // let time = new Date().getTime()
      // var img = "data:image/png;base64," + item.base64Url
      // var link = document.createElement('a');
      // link.href = img;
      // link.download = `抓拍图片${time}.png`;
      // link.click();
      this.snapImg = item.base64Url
    },
    videoDownloadSuccess(recordUrl) {
      this.$message.success("本地录像下载完成，地址为：" + recordUrl)
    },
    //上报告警
    reportAlarm() {
      this.showAlarmPanel = true;
      this.taskDetailCode = "";
      this.$refs.alarmPanel.alarmInfo.alarmLevel = ""
      this.$refs.alarmPanel.alarmInfo.alarmType = ""
      this.$refs.alarmPanel.alarmInfo.desc = ""
      this.$refs.alarmPanel.alarmInfo.picture = ""
      this.$refs.alarmPanel.alarmInfo.pictureList = []
      this.$refs.alarmPanel.alarmInfo.name = this.currentVideoInfo.channelName;
      this.$refs.alarmPanel.alarmInfo.thirdCameraId = this.currentVideoInfo.channelId;
      this.cameraList.forEach((el, ind) => {
        if (el.cameraID == this.currentVideoInfo.channelId) {
          this.taskDetailCode = el.detailCode; //赋值
        }
      });
      // console.log('this.cameraList', this.cameraList)
      // console.log('this.currentVideoInfo', this.currentVideoInfo.channelId)
      // console.log('this.taskDetailCode', this.taskDetailCode)
    },
    //全部关闭视频窗口
    handleAllStop() {
      this.curCamera.playTime = 0;
      this.$nextTick(() => {
        // this.$refs.dhPlayerPatrol.chooseWindow()
        this.$refs.dhPlayerPatrol.closeVideo()
      });
    },
    //全屏
    handleFullScreen() {
      // this.$refs.player.handleScreen();
      this.$refs.dhPlayerPatrol.setFullScreen()
    },
    base64toBlob(base64, type = 'application/octet-stream') {
      const bstr = atob(base64);
      let n = bstr.length;
      const u8arr = new Uint8Array(n);
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }
      return new Blob([u8arr], { type });
    },
    handleSnap(thirdCameraId) {
      // this.$refs.dhPlayerPatrol.snapshot(this.currentNum)
      // let formData = new FormData();
      // let file = this.base64toBlob(this.snapImg, 'image/png');
      // formData.append("files", file, new Date().getTime() + ".jpg");
      // this.$fetch("/common/file/batchFileload.json", formData).then((res) => {
      //   if (res.success) {
      //     this.$refs.alarmPanel.pictureSuccess(res);
      //   }
      // });

      let url = "/bas/event/dahua/snap/image/" + thirdCameraId;
      this.$fetchGet(url).then((response) => {
        if (response.success) {
          this.$refs.alarmPanel.pictureSuccess(response);
        } else {
          this.$message.error(response.msgContent);
        }
      });
    },
    // 列表滚动
    scrollbar() {
      let list = this.$refs.refScrollbar;
      this.boxScrollContainer = list.$el.querySelector(".el-scrollbar__wrap");
      this.scrollView = this.boxScrollContainer.querySelector(".el-scrollbar__view");
      this.scrollFun = (e) => {
        if (
          e.srcElement.scrollTop + this.boxScrollContainer.clientHeight >=
          this.scrollView.clientHeight &&
          !this.listLoading &&
          this.tasks.length % 30 === 0 &&
          this.tasks.length !== 0
        ) {
          this.pageNo = this.pageNo + 1;
          this.getTaskList();
        }
      };
      this.boxScrollContainer.addEventListener("scroll", this.scrollFun);
    },
    handleClosePanel() {
      this.showAlarmPanel = false;
    },
    showPlanListPanel() {
      this.showLeftPanel = !this.showLeftPanel;
    },
    initPage() {
      this.$map.MapInstance2D.initPage();
      const self = this;
      if (self.$route.query && self.$route.query.taskCode) {
        // webscoket 推动，手动启动
        self.copyText({ code: self.$route.query.taskCode });
      } else {
        self.getTaskList();
      }
    },
    getImgPath(item) {
      return item ? Bus.imgPath(item) : "";
    },
    pictureExceed() {
      this.$message.warning("最多可上传3张图片");
    },
    pictureBefore(file) {
      const isLt2M = file.size / 1024 / 1024 < 2;
      if (!isLt2M) {
        this.$message.error("视频大小请不要超过2MB");
      }
      return isLt2M;
    },
    pageChange(pageNo) {
      const self = this;
      self.tasks = [];
      let params = {
        pageNo: pageNo,
        pageSize: this.leftPageSize,
      };
      this.$fetch(api.videoTask.queryJobs, params).then((response) => {
        if (response.returnObj && response.returnObj.list) {
          self.total = response.returnObj.total;
          response.returnObj.list.forEach((item) => {
            if (item.taskStatus === 2 || item.taskStatus === 4) {
              self.currentTask = item;
              self.reportTime = item.planEndTime;
              self.code = item.code;
            }
            let obj = {
              startTime: item.planStartTime,
              endTime: item.planEndTime,
              name: item.taskName,
              status: item.taskStatus,
              cameras: item.cameras,
              code: item.code,
            };
            self.tasks.push(obj);
          });
        }
      });
    },
    pictureSuccess(res) {
      this.alarmInfo.pictureList = this.alarmInfo.pictureList.concat(res.returnObj || []);
    },
    getTaskList(data = {}) {
      // this.show = false;
      let params = {
        pageNo: this.pageNo,
        pageSize: this.pageSize,
      };
      Object.assign(params, data);
      this.listLoading = true;
      // console.log(params, data, "=====params");
      if (this.pageNo == 1) {
        this.tasks = [];
      }
      this.$fetch(api.videoTask.queryJobs, params).then((response) => {
        this.listLoading = false;
        if (!response.success) {
          this.$message.error("获取巡逻任务失败");
          return;
        }
        if (response.returnObj && response.returnObj.list.length) {
          // this.show = false;
          this.total = response.returnObj.total;
          // this.tasks = response.returnObj.list;
          Object.freeze(response.returnObj).list.forEach((item) => {
            // this.tasks = response.returnObj;
            // if (item.taskStatus === 2) {
            //   let param = {
            //     taskCode: item.code,
            //   };
            //   this.$fetch(api.videoTask.JobDetail, param).then((res) => {
            //     Object.freeze(res.returnObj).list.forEach((items) => {
            //       // currentTask 开始播放
            //       this.currentTask = items;
            //       this.reportTime = items.planEndTime;
            //       this.code = items.code;
            //       this.carouselType = items.weatherToPoll; //是否循环播放 1循环 0循环
            //       //地图撒点
            //       items.cameras &&
            //         items.cameras.length &&
            //         this.addCamerasOnMap(items.cameras);
            //     });
            //   });
            // }
            let obj = {
              startTime: item.planStartTime,
              endTime: item.planEndTime,
              name: item.taskName,
              status: item.taskStatus,
              cameras: item.cameras,
              code: item.code,
            };
            this.tasks.push(obj);
          });
        } else {
          //   this.show = true;
        }
      });
    },
    // 和上一个方法taskPollingAction 配合使用
    isContinuous() {
      this.handleAllStop(); //关闭视频
      // this.executeTaskTimer();
      let n = this.currentCamera;
      setTimeout(() => {
        // 更新操作（打卡，上报等操作）
        // this.$fetch(api.videoTask.updateDetail, {
        //   taskCode: this.code,
        //   taskDetailCode: this.taskDetailCode,
        // }).then((repos) => {});
        n++;
        if (n < this.currentTask.windows.length) {
          // 进行下一轮播放
          // this.currentNum = 0
          this.taskPollingAction(n);
        } else if (this.carouselType === 1 && n === this.currentTask.windows.length) {
          // 循环则从头开始播放
          // this.currentNum = 0
          this.taskPollingAction(0);
        } else {
          this.taskPlayOver = true;
          this.$message.success("视频播放完成，请及时提交报告");
        }
      }, this.currentTask.windows[n].cameras.length * 150);
    },
    // 地图渲染+视频轮播
    taskPollingAction(n) {
      this.currentNum = 0
      // this.handleAllStop();
      console.log(n, this.currentTask.cameras, "taskAction");
      // if (this.currentTask.taskStatus === 4) {
      //   return;
      // } else {
      //当前播放的摄像头
      this.taskPlayOver = false;
      this.currentCamera = n;
      let oldTime = this.reportTime - Date.now();
      // carouselType是否循环
      //判断是否轮播并且摄像机是不是最后一个提交报告按钮高亮，任务结束前10分钟方可提交
      if (this.carouselType === 1 && oldTime < 600000) {
        // 循环并且距离结束10min之内
        this.isSubmitReport = true;
      } else if (
        // 不循环并且是最后一个
        this.carouselType === 0 &&
        this.currentCamera === this.currentTask.windows.length - 1
      ) {
        this.isSubmitReport = true;
      } else {
        this.isSubmitReport = false;
      }
      const item = this.currentTask.windows[n]; //当前播放的摄像机信息
      this.cameraList = this.currentTask.cameras.map((item) => {
        return {
          isPlay: false,
          cameraID: item.cameraID,
          cameraName: item.cameraName,
          signType: item.signType,
          detailCode: item.detailCode,
        };
      });
      this.windowCode = item.windowCode;
      this.curCamera.playTime = this.curCamera.playTimeCopy;
      item.cameras.forEach((val, index) => {
        this.queryVideoRtsp({
          thirdCameraId: val.cameraID,
          name: val.cameraName,
        })
        // this.$refs.player.handlePlayLive(
        //   {
        //     thirdCameraId: val.cameraID,
        //     name: val.cameraName,
        //   },
        //   index + 1
        // );
      });
      this.cameraList.forEach((el, ind) => {
        item.cameras.forEach((val, index) => {
          // console.log(val, "播放************************");
          val.signType == "1" ? (this.isDoMark = true) : (this.isDoMark = false);
          if (el.cameraID == val.cameraID) {
            this.cameraList[ind].isPlay = true; //修改图标
          }
        });
      });
      // }
    },
    // 高亮正在轮巡的摄像机
    setCameraHighLight(cameraId) {
      // this.$map.MapInstance2D.clearShape();
      this.pointData = this.$map.MapInstance2D.cameraList;
      const idCircles = "deviceCamera";
      this.$map.MapInstance2D.updateFeatureById("CAMERA", "CAMERA-" + cameraId, {
        src: "images/theme/newDark/map/camera_selected.png",
      });
      // if (this.pointData && this.pointData.length) {
      //   this.pointData.map((item, index) => {
      //     if (item.id == cameraId) {
      //       item.src = `images/theme/newDark/map/camera_selected.png`;
      //       // this.$map.MapInstance2D.addCircles({
      //       //   longitude: item.coord[0],
      //       //   latitude: item.coord[1],
      //       //   radius: 100,
      //       //   fillColor: "#1C86EE",
      //       //   id: this.cameraPointId,
      //       //   fillColorAlpha: 0.4,
      //       // });
      //     } else {
      //       item.src = `images/theme/newDark/map/camera.png`;
      //     }
      //   });

      //   // this.$map.MapInstance2D.clearLayer("red");
      //   // this.$map.MapInstance2D.up(this.pointData, "red");
      // }
    },
    // handleShowSearch() {
    //   this.isSearch = true;
    // },
    timeChange(data) {
      this.searchForm.startTime = data[0];
      this.searchForm.endTime = data[1];
    },
    handleSearch() {
      // console.log(this.searchForm, "===this.searchForm");
      this.getTaskList(this.searchForm);
      this.isSearch = false;
    },
    handleSearchCancel() {
      this.dateRangeArr = [];
      this.searchForm = {};
      this.isSearch = false;
    },
    //执行
    handleExactor() {
      // this.handleDetailClose();
      this.handlePlayPanel({
        name: this.tableDetail.taskName,
        status: this.tableDetail.taskStatus,
        code: this.tableDetail.code,
      });
    },
    //任务详情
    handleDetail(data) {
      if (this.showDetailPanel) {
        // this.showDetailPanel = false;
        this.handleDetailClose();
        setTimeout(() => {
          this.handleDetail(data);
        }, 300);
        return;
      }
      this.activePlanInfo = { ...data };
      this.showDetailPanel = true;
      this.queryDetail(data);
    },
    doMark(isOver = false) {
      console.log(this.taskDetailCode, "=====this.taskDetailCode");
      this.$fetch("/vas/videoPatrol/updateJobDetail.json", {
        taskDetailCode: this.taskDetailCode, //新增任务明细的编码
        signStatus: 1, //打卡状态
        taskCode: this.code, //任务编码
        windowCode: this.windowCode,
      }).then((res) => {
        if (res.success) {
          this.isDoMark = false;
          this.$message.success(this.$t("videoPatrol.message.ClockSuccess"));
          //打卡后会直接进入下一个视频         2021/9/3修改
          // isOver === true ? this.isContinuous() : "";
          // if (this.carouselType === 1) {
          //   this.isContinuous();
          // }
          // this.$fetch(api.videoTask.preJobInfo, { taskCode: this.code }).then(
          //   (res) => {
          //     res.returnObj.realSignCount == this.signCount
          //       ? (this.isSubmitReport = true)
          //       : "";
          //   }
          // );
        } else {
          this.$message.error({
            message: res.msgContent,
          });
        }
      });
    },
    executeTaskTimer() {
      this.oTimer.startTaskTimer ? this.clearTimer() : "";
      // if (this.curCamera.playTime == 0)
      //   this.curCamera.playTime = this.curCamera.playTimeCopy;
      // this.curCamera.playTime = this.curCamera.playTimeCopy;
      this.oTimer.startTaskTimer = setInterval(() => {
        if (!this.curCamera.playTime || this.curCamera.playTime <= 0) {
          //当视频播放结束，根据是否打卡判断是否进入下一个视频--暂时不强制用户打卡
          // if (this.isDoMark) {
          //   this.handleAllStop();
          //   window.setTimeout(() => {
          //     this.isContinuous();
          //   }, 1000);
          // } else {
          //   this.handleAllStop();
          //   // 不需要打卡进入下一个视频
          //   this.isContinuous();
          // }
          // this.handleAllStop();
          // 不需要打卡进入下一个视频
          this.isContinuous();
          this.clearTimer();
        } else {
          this.curCamera.playTime--;
          this.panelTitle =
            this.taskName + "          本组倒计时" + this.curCamera.playTime + "秒";
        }
      }, 1000);
    },
    handlePlayPanel(item) {
      this.handleDetailClose();
      console.log(item, "巡逻信息");
      this.activePlanInfo = { ...item };
      // 因巡逻计划存在多人巡逻，且相互影响，固需根据最新状态判断
      this.$fetch(api.videoTask.JobDetail, { taskCode: item.code }).then((res) => {
        // 任务状态 1:未启动，2:执行中，3:完成，4:异常（暂停）
        if (res.success) {
          let taskStatus = res.returnObj.list[0].taskStatus || ""; //任务状态
          if (item.status != taskStatus) {
            // 如果该任务状态发生变化，更新该任务数据
            this.getTaskList();
          }
          if (taskStatus === 3) {
            this.$message.warning("该任务已结束，无法启动");
            return;
          }
          this.code = item.code;
          this.taskName = item.name;
          this.showRightPanel = true;
          if (taskStatus === 2) {
            this.$message.warning("任务已启动，继续巡逻");
          }

          if (taskStatus === 1) {
            // 第一次开启
            this.$fetch(api.videoTask.updateJob, {
              taskCode: item.code,
              taskStatus: 2,
            }).then((resUp) => {
              if (resUp.success) {
                this.$message.success(this.$t("videoPatrol.message.startSuccess"));
                this.getTaskList();
              } else {
                this.$message.warning(resUp.msgContent);
              }
            });
          }
          if (taskStatus === 4) {
            // 暂停中
            this.$fetch(api.videoTask.startJob, {
              taskCode: item.code,
            }).then((resSt) => {
              if (resSt.success) {
                this.getTaskList();
              } else {
                this.$message.warning(resSt.msgContent);
              }
            });
          }
          // 开始巡逻
          // this.$refs.player.windowNumber = res.returnObj.list[0].windowNum; //窗口数量
          this.division = res.returnObj.list[0].windowNum; //窗口数量
          this.curCamera.playTime = res.returnObj.list[0].playDuration; //巡逻间隔，时间
          this.curCamera.playTimeCopy = res.returnObj.list[0].playDuration; //巡逻间隔时间备份
          Object.freeze(res.returnObj).list.forEach((items) => {
            this.carouselType = items.weatherToPoll; //是否循环播放 1循环 0循环
            this.currentTask = items; //激活当前任务
            this.reportTime = items.planEndTime; //任务结束时间
            this.code = items.code;
            this.signCount = items.signCount; //打卡数
          });
        } else {
          this.$message.warning(res.msgContent || "获取巡逻任务详情失败");
        }
      });

      //   this.$confirm(
      //     "不在任务规定的巡逻时间段内，现在执行后任务不会变为完成状态，您确定立即执行吗？",
      //     "确认",
      //     {
      //       confirmButtonText: "确认",
      //       cancelButtonText: "取消",
      //       type: "warning",
      //     }
      //   ).then(() => {
      //     this.showRightPanel = true;
      //   });
    },
    submitReport() {
      // this.dialogVisible = true;
      // && this.curCamera.playTime <= 0//暂不对视频时间做判断
      this.isSubmitReport
        ? this.openReport()
        : this.$message.warning("播放任务未结束,请稍后提交报告");
    },
    //报告弹窗回填数据
    openReport() {
      // console.log("报告弹框");
      const self = this;
      self.dialogVisible = true;

      self.form.desc = "";
      self.$fetch(api.videoTask.preJobInfo, { taskCode: this.code }).then((res) => {
        if (res.returnObj.videoPatrolDetails.length) {
          let listPictur = [];
          for (let i = 0; i < res.returnObj.videoPatrolDetails.length; i++) {
            for (
              let j = 0;
              j < res.returnObj.videoPatrolDetails[i].videoPatrolAlarm.length;
              j++
            ) {
              for (
                let k = 0;
                k < res.returnObj.videoPatrolDetails[i].videoPatrolAlarm[j].files.length;
                k++
              ) {
                listPictur.push(
                  res.returnObj.videoPatrolDetails[i].videoPatrolAlarm[j].files[k]
                );
              }
            }
          }
          self.picList = listPictur;
        } else {
          self.showPictur = false;
        }
        self.form.processorName = res.returnObj.processorName;
        self.form.taskName = res.returnObj.taskName;
        self.form.startTime = Dates.format(res.returnObj.startTime, "HH:mm:ss");
        self.form.endTime = Dates.format(new Date(), "HH:mm:ss");
        self.form.signCount = res.returnObj.signCount;
        self.form.realSignCount = res.returnObj.realSignCount;
        self.form.miss = res.returnObj.signCount - res.returnObj.realSignCount;
        self.dialogVisible = true;
      });
    },
    //提交报告
    addReport(form) {
      this.$refs["form"].validate((valid) => {
        if (valid) {
          let param = {
            taskCode: this.code,
            signCount: this.form.signCount,
            reportDesc: this.form.desc,
            realSignCount: this.form.realSignCount,
          };
          this.$fetch(api.videoTask.JobReport, param).then((res) => {
            if (!res.success) {
              // 非巡逻任务责任人不能提交报告,显示后端返回错误信息
              let msg =
                res.msgCode == "400041204"
                  ? res.msgContent
                  : this.$t("videoPatrol.message.submitReportNo");
              this.$message.error(msg);
              this.dialogVisible = false;
              this.SubmitReport = false;
            } else {
              this.$message.success(this.$t("videoPatrol.message.submitReportYes"));
              this.form = {};
              this.SubmitReport = false;
              this.dialogVisible = false;
              this.handleClose(false);
              // this.clearTask();
              this.tasks = [];
              this.getTaskList();
            }
            // this.clearLayerData();
          });
        }
      });
    },
    //手动启动
    copyText(item) {
      this.$log.info("手动启动item", item);
      if (item.status == 1) {
        // 获取最新的任务状态进行判断
        this.$fetch(api.videoTask.JobDetail, { taskCode: item.code }).then((res) => {
          if (res.returnObj.list[0].taskStatus == 3) {
            this.$message.warning(this.$t("videoPatrol.message.hasTasked"));
            this.getTaskList();
          } else {
            this.$fetch(api.videoTask.updateJob, {
              taskCode: item.code,
              taskStatus: 2,
            }).then((res) => {
              if (res.success) {
                this.$message.success(this.$t("videoPatrol.message.startSuccess"));
                this.getTaskList();
              } else {
                this.$message.warning(res.msgContent);
              }
            });
          }
        });
      } else if (item.status == 3) {
        this.$message.warning(this.$t("videoPatrol.message.noFinishedTask"));
      } else if (item.status == 2) {
        this.$message.warning(this.$t("videoPatrol.message.startingTask"));
      } else if (item.status == 4) {
        // 获取最新的任务状态进行判断
        this.$fetch(api.videoTask.JobDetail, { taskCode: item.code }).then((res) => {
          if (res.returnObj.list[0].taskStatus == 3) {
            this.$message.warning(this.$t("videoPatrol.message.pastTask"));
            this.getTaskList();
          } else {
            this.$fetch(api.videoTask.startJob, {
              taskCode: item.code,
            })
              .then((res) => {
                if (res.success) {
                  this.getTaskList();
                } else {
                  this.$message.warning(res.msgContent);
                }
              })
              .catch(() => {
                this.$message.error(this.$t("videoPatrol.message.pastTask"));
              });
          }
        });
      } else {
        this.$fetch(api.videoTask.updateJob, {
          taskCode: item.code,
          taskStatus: 2,
        }).then((res) => {
          // console.log(res);
          if (res.msgCode == 0) {
            this.$message.success(this.$t("videoPatrol.message.startSuccess"));
            this.getTaskList();
          } else {
            this.$message.warning(res.msgContent);
          }
        });
      }
    },
    //清除轮播定时器
    clearTimer() {
      clearInterval(this.oTimer.startTaskTimer);
      this.oTimer.startTaskTimer = null;
    },
    queryDetail(data) {
      this.$fetch(api.videoTask.JobDetail, { taskCode: data.code }).then((res) => {
        if (res.success) {
          this.tableDetail = res.returnObj.list[0];
          res.returnObj.list[0].cameras.forEach((val) => {
            this.setCameraHighLight(val.deviceId);
          });
        }
      });
      // this.tableDetail = data;
    },
    // 关闭巡逻弹窗
    handleClose(isPause = true) {
      if (isPause) {
        this.$fetch(api.videoTask.updateJob, {
          taskCode: this.code,
          taskStatus: 4, //暂停
        }).then((res) => {
          this.getTaskList();
          //
        });
      }
      this.showAlarmPanel = false;
      this.showRightPanel = false;
      this.clearTimer();
      this.handleAllStop();
    },
    handleDetailClose() {
      this.activePlanInfo = null;
      this.showDetailPanel = false;
      this.$map.MapInstance2D.initPage();
    },
    convertBase64UrlToBlob(urlData) {
      var bytes = window.atob(urlData.split(",")[1]); //去掉url的头，并转换为byte
      //处理异常,将ascii码小于0的转换为大于0
      var ab = new ArrayBuffer(bytes.length);
      var ia = new Uint8Array(ab);
      for (var i = 0; i < bytes.length; i++) {
        ia[i] = bytes.charCodeAt(i);
      }
      // var blob = new Blob([ab], {type: 'image/jpeg'}); //type为图片的格式
      return new Blob([ab], { type: "image/png" });
    },
  },
};
</script>
<style lang="scss">
.el-pagination .btn-prev {
  background-color: initial;
}

.el-pagination .btn-next {
  background-color: initial;
}

.el-pager li {
  background-color: initial;
}

.el-pagination button:disabled {
  color: #c0c4cc;
  background-color: initial;
  cursor: not-allowed;
}

.hideUpload {
  .el-upload--picture-card {
    display: none;
  }
}
</style>
<style lang="scss" scoped>
@import "../style/planLeft.scss";
@import "~@src/common/assets/style/mixin";

.panel {
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
}

.left-video {
  flex: 1;
}

:deep .app-side-panel__body {
  overflow: hidden;
}

:deep .el-icon-video-play,
.el-icon-video-pause {
  color: #fff !important;
}

.planSearch {
  background: #fff;
  display: flex;
  justify-content: space-evenly;
  align-items: center;
  padding: 4px 0;

  // margin-bottom: 12px;
  span {
    height: 20px;
  }

  img {
    // width: 16px;
    // height: 16px;
    cursor: pointer;
  }
}

.item-time {
  // color: #9aa6c1;
  font-size: 12px;
}

// .panel-left_header {
//   display: inline-flex;
// }
.list-search {
  height: 40px;
  line-height: 40px;
  background-color: #262b37;
  position: relative;
  color: #8796ac;
}

.list-search_form {
  // width: 350px;
  // padding-top: 26px;
  // padding-right: 50px;
  width: 100%;
  padding: 16px;
  position: absolute;
  top: 40px;
  left: 0;
  z-index: 3;
  @include set_theme_color(background-color, input-disabled-bg-color);
}

// .no-data {
//   justify-content: center;
//   .no-data_img {
//     width: 50px;
//   }
// }
.plan-list-show {
  left: 0;
  @include set_animation(all);
}

.task-page {
  width: 100%;
  height: 100%;
}

.cur {
  position: relative;
  cursor: pointer;
  padding: 0 10px;
}

.bg {
  -webkit-animation: stretchdelay 1.2s infinite ease-in-out;
  animation: stretchdelay 1.2s infinite ease-in-out;
  width: 30px;
  height: 30px;
  border-radius: 50%;
  position: absolute;
  top: 0px;
  left: 25px;
  // background-color: rgba(0, 121, 254, 0.5);
  background-color: rgba(238, 39, 70, 0.8);
}

@keyframes stretchdelay {
  100% {
    transform: translate(-2px, -5px);
    width: 35px;
    height: 35px;
    border-radius: 50%;
  }

  0% {
    transform: translate(8px, 10px);
    width: 10px;
    height: 10px;
    border-radius: 50%;
  }
}

.file-comp {
  height: 88px;
  width: 88px;
  line-height: 88px;

  &:nth-child(3) {
    margin-right: 0;
  }
}

.delete-icon {
  position: absolute;
  right: 0;
  top: 0;
  width: 30px;
  height: 30px;
  background-color: rgba($color: #000000, $alpha: 0.5);
  cursor: pointer;
  color: #ffffff;
  display: flex;
  justify-content: center;
  align-items: center;
  transition: all 0.2s;

  &:hover {
    background-color: rgba($color: #000000, $alpha: 0.8);
  }

  &:active {
    color: #aaaaaa;
  }
}

.no-data {
  width: 100%;
  height: 800px;
  line-height: 800px;
  vertical-align: middle;
  text-align: center;
}

.pLeft {
  left: -350px;
}

.panel-left {
  z-index: 2;
  width: 350px;
  height: 100%;
  position: absolute;
  top: 0;
  // left: -350px;
  @include set_animation(all);
  // padding: 16px;
  position: relative;

  // background-color: rgba(13, 18, 28, 0.7);
  // backdrop-filter: blur(6px);
  // @include set_theme_color(background-color, map-panel);
  .item-info_left {
    width: 90%;
  }

  .data-pagination {
    text-align: center;
    height: 30px;
    line-height: 30px;
    bottom: 10px;
    left: 0;
    right: 0;
    position: absolute;
  }

  .status-btn {
    color: #fff;
    width: 65px;
    height: 22px;
    line-height: 25px;
    text-align: center;
    border-radius: 2px;
    position: absolute;
    right: 20px;
  }

  .isPending {
    background: #4b5566;
  }

  .isOther {
    background: rgba(64, 122, 238, 1);
  }

  .isFinised {
    background: rgba(53, 219, 174, 1);
  }

  .isOvertime {
    background: rgba(255, 69, 71, 1);
  }

  .panel-left_content {
    // margin-top: 10px;
    cursor: pointer;
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-box-orient: vertical;
    -webkit-line-clamp: 2;
    // height: 112px;
    border-radius: 10px;
    // padding: 14px 16px 20px 20px;
    margin: 10px;
    position: relative;
  }

  .panel-left_header {
    vertical-align: middle;
    line-height: 44px;
  }

  .content_item {
    // background: rgba(153, 153, 153, 0.5);
    padding: 12px 16px;
    font-size: 14px;
    border-radius: 5px;
  }

  .font-24 {
    font-size: 24px;
    height: 30px;
    line-height: 30px;
  }
}

.item-info {
  margin-top: 12px;
  line-height: 20px;

  .item-info_right {
    margin: auto;

    button {
      color: #fff !important;
    }
  }
}

.task-detail,
.exactor-detail {
  margin-top: 10px;
  height: 400px;
}

.task-detail,
.detail-content {
  border-radius: 5px;
  display: flex;
  flex-direction: column;
  //   padding: 10px;
  background: rgba(38, 43, 55, 0.7);
}

.detail-row {
  display: inline-flex;
  padding: 10px;
}

.detail-btn {
  margin-top: 30px;
  display: flex;
  justify-content: right;
}

.detail-title {
  height: 40px;
  line-height: 40px;
}

//执行明细
.exactor-detail {

  // padding: 5px;
  // margin-top: 20px;
  .detail-content {
    height: 240px;
    margin-top: 10px;
  }
}

//视频-左侧信息列表
.right-list {
  margin-left: 10px;
  width: 340px;

  .list-item {
    display: flex;
    font-size: 15px;
    line-height: 25px;
    padding: 8px 0;
    border-bottom: 1px solid #353e59;

    .list-item_icon {
      color: royalblue;
      font-size: 25px;
      line-height: 25px;
    }

    .list-item_index {
      margin: 0 6px;
    }
  }
}

.control-btns {
  padding: 16px 0;
  display: flex;
  justify-content: flex-end;

  i:hover {
    color: #4386ff;
  }

  .btns_play {
    i {
      padding: 20px 10px 20px 0px;
      font-size: 20px;
      cursor: pointer;
    }
  }

  .control_right {
    i {
      padding-left: 16px;
      font-size: 20px;
    }
  }
}
</style>
